import http from '@/api/http'
import { publicGet, publicRequest } from '@/entities/public/api/publicRequest'

let zonesCache = null
let zonesPromise = null

function mapZone(zone) {
  if (!zone || typeof zone !== 'object') {
    return null
  }
  const code = String(zone.code ?? '').trim()
  if (!code) {
    return null
  }
  return {
    code,
    name: String(zone.name ?? code).trim() || code,
  }
}

export async function fetchDeliveryZones({ force = false } = {}) {
  if (!force && zonesCache) {
    return zonesCache
  }
  if (!force && zonesPromise) {
    return zonesPromise
  }

  zonesPromise = publicGet('/public/delivery/zones')
    .then((payload) => {
      const data = payload?.data
      if (!data || data.type !== 'FeatureCollection' || !Array.isArray(data.features)) {
        throw new Error('Invalid delivery zones payload')
      }
      zonesCache = data
      return data
    })
    .finally(() => {
      zonesPromise = null
    })

  return zonesPromise
}

export async function checkDeliveryLocation(lat, lng) {
  const latitude = Number(lat)
  const longitude = Number(lng)
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    throw new Error('Invalid coordinates')
  }

  const payload = await publicRequest(() =>
    http.get('/public/delivery/check', {
      params: { lat: latitude, lng: longitude },
    }),
  )
  const data = payload?.data ?? {}
  const location = data.location ?? {}

  return {
    deliverable: data.deliverable === true,
    location: {
      lat: Number(location.lat ?? latitude),
      lng: Number(location.lng ?? longitude),
    },
    zone: mapZone(data.zone),
  }
}

export async function fetchPublicDeliveryFee({ restoId, lat, lng }) {
  const restaurantId = String(restoId ?? '').trim()
  const latitude = Number(lat)
  const longitude = Number(lng)
  if (!restaurantId || !Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    throw new Error('Invalid delivery fee params')
  }

  const payload = await publicRequest(() =>
    http.get('/public/delivery/fee', {
      params: {
        resto_id: restaurantId,
        lat: latitude,
        lng: longitude,
      },
    }),
  )
  const data = payload?.data ?? {}
  const fee = Number(data.delivery_fee_vnd)

  return {
    restoId: String(data.resto_id ?? restaurantId),
    deliverable: data.deliverable === true,
    deliveryFeeVnd: Number.isFinite(fee) ? Math.max(0, fee) : 0,
    currency: String(data.currency ?? 'VND').trim() || 'VND',
    zone: mapZone(data.zone),
  }
}
